// extracted by mini-css-extract-plugin
export default {"button-list":"ButtonSetting_button-list__pVODz"};